export default __webpack_public_path__ + "static/applicationSupport-ede179b3c7c18949e905dcf37b1cb7f1.svg";